// French public holidays with RRULE patterns for recurring events
export interface PublicHoliday {
  id: string;
  name: string;
  rrule: string; // RRULE pattern for yearly recurring holidays
}

export function getFrenchPublicHolidays(): PublicHoliday[] {
  return [
    {
      id: "new-year",
      name: "New Year's Day",
      rrule: "FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=1",
    },
    {
      id: "easter-monday",
      name: "Easter Monday",
      rrule: "FREQ=YEARLY;BYEASTER=1",
    },
    {
      id: "labour-day",
      name: "Labour Day",
      rrule: "FREQ=YEARLY;BYMONTH=5;BYMONTHDAY=1",
    },
    {
      id: "victory-day",
      name: "Victory Day (WWII)",
      rrule: "FREQ=YEARLY;BYMONTH=5;BYMONTHDAY=8",
    },
    {
      id: "ascension",
      name: "Ascension Day",
      rrule: "FREQ=YEARLY;BYEASTER=39",
    },
    {
      id: "pentecost-monday",
      name: "Whit Monday",
      rrule: "FREQ=YEARLY;BYEASTER=50",
    },
    {
      id: "bastille-day",
      name: "Bastille Day",
      rrule: "FREQ=YEARLY;BYMONTH=7;BYMONTHDAY=14",
    },
    {
      id: "assumption",
      name: "Assumption of Mary",
      rrule: "FREQ=YEARLY;BYMONTH=8;BYMONTHDAY=15",
    },
    {
      id: "all-saints",
      name: "All Saints' Day",
      rrule: "FREQ=YEARLY;BYMONTH=11;BYMONTHDAY=1",
    },
    {
      id: "armistice",
      name: "Armistice Day (WWI)",
      rrule: "FREQ=YEARLY;BYMONTH=11;BYMONTHDAY=11",
    },
    {
      id: "christmas",
      name: "Christmas Day",
      rrule: "FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=25",
    },
  ];
}
